<template>
  <div>
    <NavigationBar
      titel="Neuen Eintrag erstellen"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        v-model="helpers.formIsValid"
        ref="form"
        @submit.prevent="createItem"
      >
        <entry-editor v-model="entry" mode="new"></entry-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { MY_ORGANIZATION } from "@/store/modules.js";
import { CREATE_GUARDBOOK_ENTRY } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import EntryEditor from "@/components/my-organization/guardbook/GuardbookEntryEditor.vue";

export default {
  name: "my-organization-guardbook-entry-new",
  components: {
    NavigationBar,
    EntryEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.createItem,
        },
      ],

      helpers: {
        formIsValid: false,
      },
      entry: {},
    };
  },

  methods: {
    createItem() {
      this.$refs.form.validate();
      if (this.helpers.formIsValid) {
        this.$store.dispatch(`${MY_ORGANIZATION}${CREATE_GUARDBOOK_ENTRY}`, {
          organizationId: this.$route.params.organizationId,
        });
      } else {
        alert("Prüfen Deine Eingabe und versuchen es erneut.");
      }
    },
  },
};
</script>

<style></style>
